import { holderLpVaultAbi, lpTimeVaultAbi } from "../contracts/abis";
import { contractAddresses } from "../contracts/addresses";
import { useTxFlow } from "./useTxFlow";

export function useRewardActions(onMined?: () => unknown | Promise<unknown>) {
  const flow = useTxFlow(onMined);

  const send = (
    addr: `0x${string}`,
    abi: typeof holderLpVaultAbi | typeof lpTimeVaultAbi,
    fn: string,
  ) => flow.writeContractAsync({ address: addr, abi, functionName: fn as never });

  return {
    ...flow,
    registerHolder: () =>
      flow.run("开启持币分红", () =>
        send(contractAddresses.holderLpVault!, holderLpVaultAbi, "register"),
      ),
    claimHolderLp: () =>
      flow.run("领取 LP", () =>
        send(contractAddresses.holderLpVault!, holderLpVaultAbi, "claim"),
      ),
    registerLpTime: () =>
      flow.run("开启 BNB 分红", () =>
        send(contractAddresses.lpTimeVault!, lpTimeVaultAbi, "register"),
      ),
    syncLpTime: () =>
      flow.run("同步新 LP", () =>
        send(contractAddresses.lpTimeVault!, lpTimeVaultAbi, "syncBalance"),
      ),
    claimBnb: () =>
      flow.run("领取 BNB", () =>
        send(contractAddresses.lpTimeVault!, lpTimeVaultAbi, "claim"),
      ),
  };
}
